module.exports = __webpack_public_path__ + "static/media/acrobat-doc.16ac2fb4.svg";